import { BaseEntity } from "./BaseEntity";

export class QrcodeCampaignEntity extends BaseEntity {
	constructor() {
		super();
		this.entityName = "Campanha";
		this.pageTitle = "Campanha";
		this.APIRoute = "Resources/QRCode";
		this.baseEndPoint = "qrcode-campaign";
		this.endpoints = {
			list: `${this.baseEndPoint}`,
			create: `${this.baseEndPoint}`,
			get: `${this.baseEndPoint}/:id`,
			delete: `${this.baseEndPoint}/:id`,
			activate: `${this.baseEndPoint}/:id/activate`,
			deactivate: `${this.baseEndPoint}/:id/deactivate`
		};

		this.fields = [
			{ key: 'id', label: 'user.fields.id', type: 'text', visible: false, editable: false, orderBy: false, path: 'id' },
			{ key: 'name', label: 'common.labels.name', type: 'text', visible: true, required: true, editable: true, cols: 6, path: 'name' },
			{ key: 'slug', label: 'Slug', type: 'text', visible: true, required: false, editable: true, cols: 6, path: 'slug' },
			{ key: 'description', label: 'common.labels.description', type: 'textarea', visible: true, required: false, editable: true, cols: 12, path: 'description' },
			{ key: 'status', label: null, type: 'activeSwitch', visible: true, required: false, editable: true, cols: 12, path: 'status' },
		];

		this.tableColumns = [
			{ key: 'name', label: 'common.labels.name', visible: true, orderBy: true },
			{ key: 'status', label: 'common.labels.status', visible: true, orderBy: true },
			{ key: 'actions', label: 'common.labels.actions', visible: true, orderBy: false },
		];

		this.pages = {
			edit: { 
				pageTitle: 'Editar Campanha', 
				pathI18n: `components.qrcode.index.quickAccess/Campanhas`, 
				route: ['/qrcode', '/qrcode/campaigns', '/qrcode/campaigns/edit/:id'] 
			},
			create: { 
				pageTitle: 'Criar Campanha', 
				pathI18n: `components.qrcode.index.quickAccess/Campanhas`, 
				route: ['/qrcode', '/qrcode/campaigns', '/qrcode/campaigns/create'] 
			},
			list: {
				pageTitle: 'Campanhas', 
				pathI18n: `components.qrcode.index.quickAccess`,
				route: ['/qrcode', '/qrcode/campaigns'],
				filters: { quickSearch: { info: 'common.messages.info.searchByName', searchBy: ['name'], type: 'text' } }
			},
		};
	}
}

